export default __webpack_public_path__ + "static/media/partner-ship-image.1e76e576.png";